import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { seoServiceConfig } from './servicePageConfigs';

const SeoService = () => <ServicePageTemplate {...seoServiceConfig} />;

export default SeoService;
